import React from "react";
import PageHeader from "../../PageHeader";
import EditFeedbackForm from "./EditFeedbackForm";
import { ReactComponent as ExamIcon } from "../../../images/subjectimage/subjecticon.svg";
import { ReactComponent as BackIcon } from "../../../images/pageheadingicon/backicon.svg";
import useStyles from "../../../../styles";

function EditFeedback() {
  const classes = useStyles();
  const Heading = [
    {
      id: 1,
      pageicon:<ExamIcon />,
      mainheading: "Edit Feedback details",
      // subhead: "Want to Add in Bulk ? ?",
      // downloadlink: "Download bulk Sample Files",
      addbtntext: "Back",
      addbtnicon: <BackIcon />,
      addbtnstyle: "transparentbtn",
      path: "/admin/feedback",
    },
  ];
  return (
    <div className={`${classes.p2} ${classes.pb0}`}>
      <PageHeader Heading={Heading} />
      <EditFeedbackForm />
    </div>
  );
}
export default EditFeedback;
